import "./Overlay.css";

interface OverlayProps {
  show: boolean;
}

const Overlay = (props: OverlayProps) => {
  return (
    props.show ? (
      <div className="overlay">

      </div>
    ) : <></>
  );
};

export default Overlay;